import { render, staticRenderFns } from "./SectionVision.vue?vue&type=template&id=179ee056&scoped=true"
import script from "./SectionVision.vue?vue&type=script&lang=ts"
export * from "./SectionVision.vue?vue&type=script&lang=ts"
import style0 from "./SectionVision.vue?vue&type=style&index=0&id=179ee056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179ee056",
  null
  
)

export default component.exports